import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListStudentFee = createAsyncThunk(
  'school-student-fee-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentList
export const ListStudent = createAsyncThunk('school-student-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/get-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentFeeDetails = createAsyncThunk(
  'school-student-fee-details',
  async (student_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/student-details/` + student_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const studentFeeStore = createAsyncThunk(
  'school-student-fee-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student-fee/store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const editStudentFee = createAsyncThunk(
  'school-student-fee-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/school-student-fee/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentFees = createAsyncThunk('school-student-fees', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/student-fees/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const printStudentFee = createAsyncThunk(
  'student-fee-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentFee = createAsyncThunk(
  'student-fee-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`${api}school-student-fee/delete/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InactiveFeeInv = createAsyncThunk('inactive-inv', async (dat: any, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}school-student-fee/inactive-invoice`, dat)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const InactiveTransInv = createAsyncThunk(
  'inactive-trans-inv',
  async (dat: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}student-transport-payments/inactive-invoice`, dat)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const feePaymentStore = createAsyncThunk(
  'school-student-fee-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student-fee/payment-store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getStudentFeesReport = createAsyncThunk(
  'get-student-fees-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-fee/get-student-fees-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printFeeReport = createAsyncThunk('print-fee-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student-fee/print-student-fees-report`, data)

    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const FeeExcelReport = createAsyncThunk('fees-excel', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-fee/student-fees-excel-report`, {
      params,
      responseType: 'blob',
    })
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
  }
})

export const studentFeeDetails = createAsyncThunk(
  'school-student-fee-details',
  async (student_fee_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-fee/details/` + student_fee_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const feePaymentSummary = createAsyncThunk(
  'school-student-fee-payment-summary',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-fee/payment-summary`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const feePaymentChart = createAsyncThunk(
  'school-student-fee-payment-chart',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-fee/payment-chart`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const YearlyFeeDetails = createAsyncThunk('yearly-fee-rep', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student-fee/yearly-std-fee-details`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const YearlyFeePrint = createAsyncThunk('yearly-fee-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student-fee/yearly-fee-details-print`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const YearlyFeeExcel = createAsyncThunk(
  'yearly-fee-excel',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-fee/yearly-fee-details-excel`, data, {
        responseType: 'blob', // ✅ THIS FIXES YOUR ISSUE
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
      return thunkAPI.rejectWithValue('Download failed')
    }
  }
)

export const MonthlyFeeDetails = createAsyncThunk('monthly-fee-rep', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student-fee/monthly-std-fee-details`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MonthlyFeePrint = createAsyncThunk('monthly-fee-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-student-fee/monthly-fee-details-print`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MonthlyFeeExcel = createAsyncThunk(
  'monthly-fee-excel',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}school-student-fee/monthly-fee-details-excel`,
        data,
        {
          responseType: 'blob', // ✅ THIS FIXES YOUR ISSUE
        }
      )

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
      return thunkAPI.rejectWithValue('Download failed')
    }
  }
)

export const StudentList = createAsyncThunk('students', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-student-fee/students`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ReportOptions = createAsyncThunk('options', async (period: string, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-student-fee/report-options/${period}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

type StudentFeeState = {
  errors: any
}

const initialState: StudentFeeState = {
  errors: '',
}

export const studentFeeSlice = createSlice({
  name: 'student-fee',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentFeeSlice.actions
export default studentFeeSlice.reducer
